var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),(_vm.filterFormArea)?_c('div',{staticClass:"filtrate-form"},[_vm._t("filter-form")],2):_vm._e(),(_vm.$slots['btn-bar'])?_c('div',{staticClass:"btn-bar"},[_vm._t("btn-bar")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }